module.exports = __webpack_public_path__ + "static/media/business_hours.bb1a51fd.svg";